import React from "react"

export default function Dot(){
    return(
        <span className="dot"> </span>
    )
}